module.exports = __webpack_public_path__ + "img/ic_bianjiebaoxiu.434b1258.svg";